import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { getAxiosResponse, handleError, putAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import $ from "jquery";
import { useSelector } from "react-redux";
import { postAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import Constants from "../../../Constants";

export default function OverviewAlerts(prop) {

  const projectStatus = prop.project.displayName[0].status;
  const project = prop.project.resource.projectResource;
  const [sourceSyncErrors, setSourceSyncErrors] = useState([]);
  const [targetSyncErrors, setTargetsyncErrors] = useState([]);
  const [invalidSourceFile,setInvalidSourceFile] = useState([]);
  const [internalTranslation, setInternalTranslationRequest] = useState({});

  const navigate = useNavigate()
  const openPoup = () => {
    prop.funct();
    $(document.activeElement).addClass('showPopup');
  };
  const custBootstrapDataRedux = useSelector((store) => store.customer_bootstrap_data).value;
  const roleSet = custBootstrapDataRedux?.roleSet?.roleTypes;
  const owner = useSelector((reduxStore) => reduxStore.loginSession).value;

  let isCustomerUser = false;
    if(roleSet && roleSet.length > 0) {
       isCustomerUser = roleSet.some(element => {
        if (element.value === 'ROLE_CUSTOMER') {
          return true;
        }
        return false;
      });
    }
  let isInternalTranslatorUser = false;
    if(roleSet && roleSet.length > 0) {
        isInternalTranslatorUser = roleSet.some(element => {
        if (element.value === 'ROLE_CUSTOMER_INTERNAL_TRANSLATOR') {
          return true;
        }
        return false;
      });
    }
  const retrySourceSync = () =>{
    confirmAlert({
      title: "Retry Source Sync",
      message: <p>Retry source asset preparation?</p>,
      buttons: [
        {
          label: "Retry",
          onClick: () =>
            postAxiosResponse(APIUrls.RETRY_INTEGRATION_SYNC(project.id)).then((res) => {
              prop.refresh("overView");
            }),
        },
        {
          label: "Cancel",
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    });
  }

  const openRequestTranslationPopup = () => {
    prop.requestTranslationAgainFunct();
  };
 const showConfirmPopup = (msg,payload) =>{
    confirmAlert({
      title: "Close Project",
      message: <p>{`${msg}`}</p>,
      buttons: [
        {
          label: "Accept",
          onClick: () => putAxiosResponse(APIUrls.PROJECT(project.id),payload).then((res) => {
            prop.refresh("overView");
          }),
        },
        {
          label: "Cancel",
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    });
  }
  const confirmCloseProject = (type, title) => {
   var msg = `${title}`;
    var payload = {
      id: project.id,
      status: "PROJECT_CLOSED"
    }
    
    
    switch (type) {
   case "internal" :
      return showConfirmPopup(msg,payload);
   case "machineTranslation":
    return  showConfirmPopup(msg,payload)
   case "skipTm":
      return showConfirmPopup(msg,payload)
    default :
      showConfirmPopup(msg,payload)
  };
}
  const errorTypeDisplay =(errorType)=> {
    if (errorType === 'UNAUTHORIZED'){
      return "Login Failed"
    }else if(errorType === 'FORBIDDEN'){
      return "Permission Issue"
    }
    else if(errorType === 'DOCUMENT_NOT_FOUND'){
      return "Asset Not Found"
    }
    else if(errorType === 'PREVIEW_GENERATION_FAILED'){
      return "Preview Generation Failed"
    } 
    else if(errorType === 'SOURCE_SYNC'){
      return "Unexpected Error"
    }
  }
  const errorExplanation = (errorType)=> {
    if (errorType === 'UNAUTHORIZED'){
      return <p className="text-wrap">We were unable to access your content with the credentials provided. Please <Link target="_blank"  to={"settings/myaccount/integration"}>re-enter your credentials</Link>, then click Retry below.</p>
    }else if(errorType === 'FORBIDDEN'){
      return <p className="text-wrap">Your credentials do not give proper access to this asset. Review this asset's permissions and confirm they are adequate, then click Retry.</p>
    }
    else if(errorType === 'DOCUMENT_NOT_FOUND'){
      return <p className="text-wrap">This asset no longer exists. Please cancel and re-create the project without this asset selected.</p>
    }
    else if(errorType === 'PREVIEW_GENERATION_FAILED'){
      return <p className="text-wrap">An error occurred while generating your asset's preview. Please <Link target="_blank" to="https://cloudwords.zendesk.com/hc/en-us/requests/new">contact OPAL-Marketing support</Link> for further assistance.</p>
    } 
    else if(errorType === 'SOURCE_SYNC'){
      return <p className="text-wrap">An unexpected error occurred while attempting to prepare this asset. Please retry. If the issue persists, <Link target="_blank" to="https://cloudwords.zendesk.com/hc/en-us/requests/new">contact OPAL-Marketing support</Link>.</p>
    }
  }
  const getSourceSyncErrors = () => {
    if (projectStatus.code !== "source_sync_failed") {
      //no errors to return
      return false;
    } else {
      var retryableErrorTypes = [
        "UNAUTHORIZED",
        "FORBIDDEN",
        "PREVIEW_GENERATION_FAILED",
        "SOURCE_SYNC",
      ];
      var syncErrorTypes = [
        "UNAUTHORIZED",
        "FORBIDDEN",
        "DOCUMENT_NOT_FOUND",
        "PREVIEW_GENERATION_FAILED",
        "SOURCE_SYNC",
      ];

      var retryable = false;
      var errorArray = project.syncErrors.filter((error) => {
        //if at least 1 retryable error, show the retry button
        if (retryableErrorTypes.includes(error.errorType)) {
          retryable = true;
        }
        return syncErrorTypes.includes(error.errorType);
      });
      return {
        retryable: retryable,
        errors: errorArray,
      };
    }
  };
  const getTargetErrorUrl = (errorLang) =>{
    var langcode = prop.project.displayName[0].targetLanguages?.filter((lang)=>{
      return lang.language === errorLang 
    })
    return <Link onClick={(e)=>{e.preventDefault();navigate(`/project/${project.id}`,{state:{tab:'overView',langCode:langcode[0]?.code}})}}>
                             {errorLang}
                           </Link>
  }
  const getTargetSyncError = () => {
    if (project.status.code !== "target_sync_failed") {
      //no errors to return
      return false;
    } else {
      var retryableErrorTypes = [
        "UNAUTHORIZED",
        "FORBIDDEN",
        "PREVIEW_GENERATION_FAILED",
        "TARGET_SYNC",
      ];
      var syncErrorTypes = [
        "UNAUTHORIZED",
        "FORBIDDEN",
        "DOCUMENT_NOT_FOUND",
        "PREVIEW_GENERATION_FAILED",
        "TARGET_SYNC",
      ];

      var retryable = false;
      var errorArray = project.syncErrors.filter((error) => {
        //if at least 1 retryable error, show the retry button
        if (retryableErrorTypes.includes(error.errorType)) {
          retryable = true;
        }
        return syncErrorTypes.includes(error.errorType);
      });
      return {
        retryable: retryable,
        errors: errorArray,
      };
    }
  };
  const getSyncErrorsByType = (error) =>	{
    var errorArray = []
    var projectSyncErrors = project.syncErrors;
    if (projectSyncErrors && projectSyncErrors.length > 0) {
      for (var i = 0; i < projectSyncErrors.length; i++) {
        if (projectSyncErrors[i].errorType == error) {
          errorArray.push(projectSyncErrors[i]);
        }
      }
    }
    return errorArray;
  }
  const isTranslator = () =>{
    return false
  }
  useEffect(() => {
    var targetErrors = []
    if(project.syncErrors !== ''){
      var errors = getSourceSyncErrors();
      setSourceSyncErrors(errors);
    }
    targetErrors = getTargetSyncError();
    if(!targetErrors){
      targetErrors = getSyncErrorsByType('TARGET_SYNC')
      setTargetsyncErrors(targetErrors);
    }else{
      setTargetsyncErrors(targetErrors);
    }
    var invalidSourceFile = getSyncErrorsByType('INVALID_SOURCE_FILE')
    setInvalidSourceFile(invalidSourceFile);

    getAxiosResponse(APIUrls.INTERNAL_REQUEST(project.id))
      .then((res) => {
        if (res.data !== "") {
          setInternalTranslationRequest(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  }, []);

  const isContextUserAssignee = () => {
    if(internalTranslation?.assigneeUser !== undefined) {
      return owner.id === internalTranslation.assigneeUser.userId;
    }
  }

  return (
      (()=>{
       if(isCustomerUser || isInternalTranslatorUser) {
         if(prop.project !== undefined){
           if (projectStatus.code === "no_bids_submitted") {
             return (
               <div className="error-in-bids flex-center static-detail bid-alert-view-width">
                 <div className="alert mar-bot16">
                   None of the vendor(s) that this project was sent to have -
                   submitted a quote. Clicking "Update and Request Quotes Again" will
                   allow you to update your project details and request quotes again.
                   Alternatively, you can{" "} <Link to={`/project-details-edit/${project.id}`}>cancel this project</Link>.
                 </div>
                 <div className="flex justify-end w-d100">
                  <button className="btn" onClick={openPoup}>
                    Update and Request Quotes Again
                  </button>
                 </div>
               </div>
             );
           } else if (projectStatus.code === "internal_translator_rejected" && !isContextUserAssignee()) {
             return (
               <div className="error-in-bids flex-center static-detail bid-alert-view-width">
                 <div className="alert mar-bot16">
                 The internal translator has rejected your request. Clicking "Request Translation Again" will allow you to request translation from the same or a different internal translator. Alternatively, you can{" "} <Link to={`/project-details-edit/${project.id}`}>cancel this project</Link>.
                 </div>
                 <div className="flex justify-end w-d100">
                  <button className="blue-btn active requestBtn" onClick={openRequestTranslationPopup}>
                    Request Translation Again
                  </button>
                  </div>
               </div>
             );
           } 
           else if (projectStatus.code === "vendor_rejected") {
            return (
              <div className="error-in-bids flex-center static-detail bid-alert-view-width">
                <div className="alert mar-bot16">
                The vendor has rejected your request. Clicking "Request Translation Again" will allow you to request translation from the same or a different preferred vendor.
                  
                   Alternatively, you can{" "}
                  <Link to={`/project-details-edit/${project.id}`}>cancel this project</Link>.
                </div>
                <div className="flex justify-end w-d100">
                 <button className="blue-btn active requestBtn" onClick={openRequestTranslationPopup}>
                 Request Translation Again
                 </button>
                </div>
              </div>
            );
          }
           else if (projectStatus.code === "all_bids_rejected") {
             return (
               <div className="error-in-bids flex-center static-detail bid-alert-view-width">
                 <div className="alert mar-bot16">
                   The vendor(s) that this project was sent to have rejected the
                   opportunity to submit a quote. Clicking "Update and Request Quotes
                   Again" will allow you to update your project details and request
                   quotes again. Alternatively, you can{" "} <Link to={`/project-details-edit/${project.id}`}>cancel this project</Link>.
                 </div>
                 <div className="flex justify-end w-d100">
                  <button className="btn" onClick={openPoup}>
                    Update and Request Quotes Again
                  </button>
                 </div>
               </div>
             );
           } else if (projectStatus.code === "bid_selection_expired") {
             return (
               <div className="error-in-bids flex-center static-detail bid-alert-view-width">
                 <div className="alert mar-bot16">
                   The deadline to choose a winning quote has passed. Click "Update
                   and Request Quotes Again" to update your project details and
                   request quotes again.
                   <br />
                   <br />
                   Vendors who previously submitted quotes can then resubmit their
                   original quotes or update their quotes. Alternatively, you can{" "}
                   <Link to={`/project-details-edit/${project.id}`}>cancel this project</Link>.
                 </div>
                 <div className="flex justify-end w-d100">
                  <button className="btn" onClick={openPoup}>
                    Update and Request Quotes Again
                  </button>
                 </div>
               </div>
             );
           } 
            else if (sourceSyncErrors && sourceSyncErrors.errors) {
              return(
                <div className="error-in-bids flex-center static-detail">
                   <div className="alert mar-bot16" >
                     <h4>Sync Error</h4>
                    { sourceSyncErrors.retryable ? <p>{Constants.SYNC_ERROR.SOURCE_SYNC_ERROR_RETRYABLE}</p> : <p>{Constants.SYNC_ERROR.SOURCE_SYNC_ERROR_NOT_RETRYABLE}</p>}
                   </div>
                   <div className="relative table-responsive">
                    <table className="bids-table-list relative">
                      <thead>
                        <tr>
                          <th>Asset Name</th><th>Asset ID</th><th>Error</th><th>Explanation</th>
                        </tr>
                      </thead>
                        {sourceSyncErrors.errors.map((error)=>{
                          return <tr>
                            <td>{error.asset && error.asset.url ? <Link target="_blank" to={error.asset.url}>{error.asset.name}</Link> : error.asset.name}</td>
                            <td>{error.asset.externalId}</td>
                            <td>{errorTypeDisplay(error.errorType)}</td>
                            <td>{errorExplanation(error.errorType)}</td>
                            </tr> 
                        })}
                    </table>
                   </div>
                   <div className="flex  w-d100 flex-center " style={{justifyContent:"space-between"}}>
                   <div className="left flex">
                      For more details, view the <Link style={{marginLeft:"10px"}} target="_blank" to="https://cloudwords.zendesk.com/hc/en-us/articles/360007905953-Synchronization-Errors">sync error documentation</Link>.
                    </div>
                    {sourceSyncErrors && sourceSyncErrors.retryable ? 
                    <div className="left right-sidebtn flex">
                    <button className="btn" onClick={retrySourceSync}>
                    Retry
                  </button>
                  </div> : ''
                    }
                 </div>
                 </div>
                )
           } else if (targetSyncErrors != null && targetSyncErrors.length > 0) {
               return (
                
                 <div className="error-in-bids flex-center static-detail bid-alert-view-width">
                   <div className="alert mar-bot16">
                     <p>
                       We are unable to sync the target content due to an error.
                       Please double check the assets in your system. The following
                       assets could not be synced: 
                       {targetSyncErrors.map((error,index) => {
                 return <span key={index}> {" "}
                         {error.assetType} {error.externalId}&nbsp;
                         {error.language ? (
                            getTargetErrorUrl(error.language)
                         ) : (
                           ""
                         )}
                       </span>
                        })}
                     </p>
                   </div>
                 </div>)
           } else if (invalidSourceFile.length > 0){
            return (
                
              <div className="error-in-bids flex-center static-detail bid-alert-view-width">
                <div className="alert mar-bot16">
                  <p>
                  The project contains source files that are invalid. Click on the "Source Files" tab to correct these files.
                    
                  </p>
                </div>
              </div>)
           }
           else if(project.projectSubmittable && project.userCanAlterProject) {
            return (<div className="error-in-bids flex-center static-detail bid-alert-view-width">
                <div className="alert mar-bot16">
             {(() => {
              if(project.projectVendorType === "INTERNAL"){
                if(isTranslator()){
                  return <p>All translations for this project have been approved. Be sure to upload any new Translation Memory before closing this project (if applicable). Close this project to ensure it appears in your reports.</p>
                }else{
                 return <p>All translations for this project have been approved. Be sure the translator uploads any new Translation Memory before closing this project (if applicable). Close this project to ensure it appears in your reports.</p>
                }
              }
              else if(project.projectVendorType === "MACHINE_TRANSLATION"){
                  return <p>All translations for this project have been approved. Close this project to ensure it appears in your reports.</p>
              }else if(project.skipTmUpload){
                  return <p>The customer has approved all languages and is not requiring translation memory for this project. To finalize it, click the <b>Submit and Close Project</b> button. Payment will be issued only after this project is closed.</p>
              }else{
                  return <p>You have successfully uploaded the translation memory. To send it to the customer, click the <b>Submit and Close Project</b> button. Project will be closed and payment issued only after the translation memory file(s) have been uploaded and the project submitted.</p>
              }
             })()}
                </div>
                <div className="flex justify-end w-d100">
                {(() => { 
                  var title = ''
                   if(project.projectVendorType === "INTERNAL"){
                    title = "Click accept to close this project. Once this project is closed, it cannot be re-opened and the translator will not be able to upload new Translation Memory. This operation cannot be undone."
                    return <button className="btn" onClick={()=> confirmCloseProject('internal',title)}>
                    Close Project
                    </button>
                   }
                   else if(project.projectVendorType === "MACHINE_TRANSLATION"){
                    title = "Click accept to close this project. Once this project is closed, it cannot be re-opened. This operation cannot be undone."
                    return <button className="btn" onClick={()=>confirmCloseProject('machineTranslation',title)}>
                    Close Project
                    </button>
                   }else if(project.skipTmUpload){
                    title = "Click Accept to finalize and close the project.By submitting and closing the project, you will not be able to upload or modify any files.Payment will only be issued after you click Accept to submit the project."
                    return <button className="btn" onClick={()=>confirmCloseProject('skipTm',title)}>
                    Close Project
                    </button>
                   }else{
                    title = "Click Accept to submit the translation memory to the customer and close the project.By submitting and closing the project, you will not be able to upload or modify any files.Payment will only be issued after you click Accept to submit the project.Click Cancel if you need to upload new Translation Memory files."
                    return <button className="btn" onClick={()=>confirmCloseProject('vendor',title)}>
                    Close Project
                    </button>
                   }
                 })()}
                 </div>
              </div>)
           }
           else {
             return "";
           }
         }
        }
         
   })()
  )
}
